export default "__VITE_ASSET__CT9$ho5T__"